// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2lUQY","title":"Info_title__14hAW","selects":"Info_selects__2mzjZ","requiredAsterisk":"Info_requiredAsterisk__nvdTR"};